export default "__VITE_ASSET__BN8vwE$M__"